'use client';
var classes = {"root":"m_9e117634"};

export { classes as default };
//# sourceMappingURL=Image.module.css.mjs.map
